export const BREAK_EXPLANATION_CONSTANTS = {
  MIN_CHARACTERS: 60,
  MAX_CHARACTERS: 300,
} as const;
